import { render } from "./Header.vue?vue&type=template&id=61dd7a3d"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61dd7a3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61dd7a3d', __exports__)) {
    api.reload('61dd7a3d', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=61dd7a3d", () => {
    api.rerender('61dd7a3d', render)
  })

}


export default __exports__